import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { BaseService } from './base.service';
import { ScheduleNotification, ReadingNote } from '../index';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { AppConfig } from '../../app.config';

@Injectable()
export class SubscriptionService extends BaseService {

    constructor(private http: Http, private config: AppConfig) { super(); }


    getSubscribers() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/subscriptions/subscribers', { headers }).pipe(map((response: Response) => {
            //console.log(response);
            return response.json();
        }),catchError(this.handleError))
    }

    getSubscriber(subscriberId):any {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/subscriptions/subscribers/' + subscriberId, { headers })
            .pipe(map((response: Response) => {
            //console.log(response);
            return response.json();
        }),catchError(this.handleError))
    }

    getSubscriberMessages(): any {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/subscriptions/subscriber/messages', { headers })
            .pipe(map((response: Response) => {
            //console.log(response);
            return response.json();
        }),catchError(this.handleError))
    }

    getSubscriberQueueMessages(): any {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/subscriptions/subscriber/queuemessages', { headers })
            .pipe(map((response: Response) => {
            //console.log(response);
            return response.json();
        }),catchError(this.handleError))
    }

    SaveSubscription(notification: ScheduleNotification) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/subscriptions/create', notification, { headers })
            .pipe(map((response: Response) => {
            //console.log(response);
            return response.json();
        }),catchError(this.handleError))
    }

    UpdateSubscription(notification: ScheduleNotification) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/subscriptions/update', notification, { headers })
            .pipe(map((response: Response) => {
            //console.log(response);
            return response.json();
        }),catchError(this.handleError))
    }

    deleteSubscription(notification: ScheduleNotification) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/subscriptions/delete', notification, { headers })
            .pipe(map((response: Response) => {
            //console.log(response);
            return response.json();
        }),catchError(this.handleError))
    }

    getBreachedMessage(messageId,pin):any {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        //let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        //headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/subscriptions/subscribers/messages/' + messageId + "?pin=" + pin, { headers })
            .pipe(map((response: Response) => {
            //console.log(response);
            return response.json();
        }),catchError(this.handleError))
    }


    addReadingNote(note) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        //let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        //headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/readings/addnote', note, { headers })
            .pipe(map((response: Response) => {
            //console.log(response);
            return response.json();
        }),catchError(this.handleError))
    }

}




// WEBPACK FOOTER //
// ./src/app/shared/services/subscription.service.ts